import SideBar from '../components/SideBar';

import { ReactComponent as DashboardIcon } from '../components/svgs/dashboardicon.svg';
import { ReactComponent as OrderIcon } from '../components/svgs/ordersicon.svg';
import { ReactComponent as CustomerIcon } from '../components/svgs/customersicon.svg';

import Header from '../components/Header';
import OrderStatusCard from '../components/OrderStatusCard';
import {ReactComponent as TimerIcon} from '../components/svgs/timericon.svg';
import {ReactComponent as CarlenderIcon} from '../components/svgs/carlendericon.svg';
import {ReactComponent as LaundryMachineIcon} from '../components/svgs/laundrymachineicon.svg';
import {ReactComponent as ShippingBoxIcon} from '../components/svgs/shippingboxicon.svg';
import TabComponent from '../components/Tab';
import SideCard from '../components/SideCard';
import StatusDropdown from '../components/StatusDropdown';

// laundry status data
const laundryStatus = [
  { label: 'All', link: '#' },
  { label: 'Binned', link: '#' },
  { label: 'Washing', link: '#' },
  { label: 'Drying', link: '#' },
  { label: 'Folding', link: '#' },
];

// laundry days data
const laundryDays = [
  { label: 'Today', link: '#' },
  { label: 'Last 7 Days', link: '#' },
  { label: 'Last 14 Days', link: '#' },
  { label: 'Last 30 Days', link: '#' },
  { label: 'All Time', link: '#' },
];

const AttendantSidebarLinks = [
  { to: '/', icon: <DashboardIcon />, text: 'Dashboard', isActive: true },
  { to: '/orders', icon: <OrderIcon />, text: 'Orders', isActive: false },
  { to: '/customers', icon: <CustomerIcon />, text: 'Customers', isActive: false },
 
];

const Dashboard = () => {

  return (
    <>

      <section className='dashboard-container flex '>
        <aside className=''>
        <SideBar links={AttendantSidebarLinks} />
        </aside>
        <main className='main-container mb-32'>
          <Header orderTitle={'Welcome Rachel'} orderSubtitle={'Here’s how things are looking'} showButton={true}/>
          <section className='mt-10 flex gap-5'>
            <OrderStatusCard icon={<TimerIcon/>} noOfOrders={8} dueDay={true}  orderText={'orders'} size={'12'} dueDate={new Date()}/>
            <OrderStatusCard icon={<CarlenderIcon/>} noOfOrders={4} noOfOrdersClassName="custom-style" dueDay="Today" orderText={'orders'} size={'8'} dueDate={new Date()}/>
            <OrderStatusCard icon={<TimerIcon/>} noOfOrders={11} noOfOrdersClassName="custom-style" dueDay="Tomorrow" orderText={'orders'} size={'15'} dueDate={new Date()}/>
            <OrderStatusCard icon={<LaundryMachineIcon/>} noOfOrders={23} noOfOrdersClassName="custom-style" dueDay={"In Laundry"} orderText={'orders'} size={'24'} dueDate={new Date()} dropDown={<StatusDropdown options={laundryStatus} dropdownText={'All'} className="ml-20" />}/>
            <OrderStatusCard icon={<ShippingBoxIcon/>} noOfOrders={19} noOfOrdersClassName="custom-style" dueDay={"Ready for Pickup"} orderText={'orders'} size={'12'} dueDate={new Date()} dropDown={<StatusDropdown options={laundryDays} dropdownText={'Today'} className="status-card-dropdown-today" />}/>
          </section>
          <section className='mt-20 flex gap-4'>
            <section>
              <TabComponent/>
            </section>
            <section className='side-card-section'>
              <SideCard/>
            </section>
          </section>
        </main>
      </section>

    </>
  )
}
export default Dashboard